export const saveAuth = (data) => {
  localStorage.setItem("pos_token", data.token);
  localStorage.setItem("pos_user", JSON.stringify(data.user));
};

export const getAuthUser = () => {
  try {
    const user = localStorage.getItem("pos_user");
    return user ? JSON.parse(user) : null;
  } catch {
    return null;
  }
};

export const getAuthToken = () => {
  return localStorage.getItem("pos_token");
};

export const isLoggedIn = () => {
  return !!getAuthToken() && !!getAuthUser();
};

export const getCurrentUser = () => {
  return getAuthUser();
};

export const getCurrentShopId = () => {
  const user = getAuthUser();
  return Number(user?.shop_id || user?.shopId || 1);
};

export const getCurrentUserRole = () => {
  const user = getAuthUser();
  return user?.role || "";
};

export const isSuperAdmin = () => {
  return getCurrentUserRole() === "super_admin";
};

export const logout = () => {
  localStorage.removeItem("pos_token");
  localStorage.removeItem("pos_user");
};